import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// On-demand Element UI — explicit deep paths (the barrel import does NOT
// tree-shake in this Vite build). Only the components actually used.
import Button from "element-ui/lib/button";
import Carousel from "element-ui/lib/carousel";
import CarouselItem from "element-ui/lib/carousel-item";
import Checkbox from "element-ui/lib/checkbox";
import CheckboxGroup from "element-ui/lib/checkbox-group";
import Dialog from "element-ui/lib/dialog";
import Dropdown from "element-ui/lib/dropdown";
import DropdownItem from "element-ui/lib/dropdown-item";
import DropdownMenu from "element-ui/lib/dropdown-menu";
import Option from "element-ui/lib/option";
import Popover from "element-ui/lib/popover";
import Select from "element-ui/lib/select";
import Tooltip from "element-ui/lib/tooltip";
// Loading via deep path (NOT `{ Loading } from "element-ui"` — that pulls the full lib).
import Loading from "element-ui/lib/loading";

import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/en";

// Keep the full theme stylesheet: it guarantees styles for Select's internal
// sub-components (dropdown, scrollbar, tag, input, popper) without a fragile
// per-component CSS list, and with cssCodeSplit:false it all merges into
// main.min.css anyway.
import "element-ui/lib/theme-chalk/index.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "v-mapbox/dist/v-mapbox.css";
import "vue-sliding-pagination/dist/style/vue-sliding-pagination.css";

locale.use(lang.default || lang);

Vue.use(Button);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Option);
Vue.use(Popover);
Vue.use(Select);
Vue.use(Tooltip);
Vue.use(Loading.directive); // registers v-loading; no programmatic service used

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#store-locator-app");
